import { URL } from '../../constants/insurance/constant';
import { _axios } from '../../plugins/axios';

export const CheckDuplicacy = (formData, localStorageData) => {
  let config = {
    method: 'post',
    // url: 'https://api-plus.medibuddy.in/CheckEsalesOrderDuplicacy',
    headers: {
      accesstoken: JSON.parse(localStorageData.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    data: formData
  };

  return _axios(config)
    .then((response) => {
      if (response.data.isSuccess) {
        if (response.data.isDuplicate) {
          formData.isCart = false;
          // UtilitiesService.showAlertMessage('We already have appointment similar to this request, please check before you proceed.');
          console.log('We already have appointment similar to this request, please check before you proceed.');
        } else {
          // createAppointment(formData, localStorageData);
          axiosCallToCreateAppointment(formData, localStorageData);
        }
      } else {
        // UtilitiesService.showAlertMessage('Unable to proceed in booking order');
        console.log("Unable to proceed in booking order");
      }
    })
    .catch((error) => error);
}

export const axiosCallToCreateAppointment = (formData) => {
  let config = {
    method: 'post',
    // url: 'https://ch-api-procheck.medibuddy.in/order',
    url: URL.providercore_url + 'insurance/createAppointment',
    // url: 'https://api-plus.medibuddy.in/order',
    headers: {
      AccessToken: JSON.parse(localStorage.getItem("access_token")),
      accesstoken: JSON.parse(localStorage.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    data: {
      ...formData,
      "accesstoken" : JSON.parse(localStorage.getItem("access_token"))
    }
  };
  return _axios(config)
    .then((response) => response.data )
    .catch((error) => error);
}